"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Share_exports = {};
__export(Share_exports, {
  default: () => Share_default
});
module.exports = __toCommonJS(Share_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.94922 8.57031C5.50651 8.57031 5.1224 8.73307 4.79688 9.05859C4.48438 9.37109 4.32812 9.75521 4.32812 10.2109C4.32812 10.6536 4.48438 11.0378 4.79688 11.3633C5.1224 11.6758 5.50651 11.832 5.94922 11.832C6.40495 11.832 6.78906 11.6758 7.10156 11.3633C7.42708 11.0378 7.58984 10.6536 7.58984 10.2109C7.58984 9.75521 7.42708 9.37109 7.10156 9.05859C6.78906 8.73307 6.40495 8.57031 5.94922 8.57031ZM3.33203 10.2109C3.33203 9.48177 3.58594 8.86328 4.09375 8.35547C4.61458 7.83464 5.23307 7.57422 5.94922 7.57422C6.67839 7.57422 7.29688 7.83464 7.80469 8.35547C8.32552 8.86328 8.58594 9.48177 8.58594 10.2109C8.58594 10.9271 8.32552 11.5456 7.80469 12.0664C7.29688 12.5742 6.67839 12.8281 5.94922 12.8281C5.23307 12.8281 4.61458 12.5742 4.09375 12.0664C3.58594 11.5456 3.33203 10.9271 3.33203 10.2109ZM14.4648 13.668C14.0091 13.668 13.6185 13.8307 13.293 14.1562C12.9805 14.4688 12.8242 14.8529 12.8242 15.3086C12.8242 15.7513 12.9805 16.1354 13.293 16.4609C13.6185 16.7734 14.0091 16.9297 14.4648 16.9297C14.9076 16.9297 15.2852 16.7734 15.5977 16.4609C15.9232 16.1354 16.0859 15.7513 16.0859 15.3086C16.0859 14.8529 15.9232 14.4688 15.5977 14.1562C15.2852 13.8307 14.9076 13.668 14.4648 13.668ZM11.8281 15.3086C11.8281 14.5794 12.082 13.9609 12.5898 13.4531C13.1107 12.9323 13.7357 12.6719 14.4648 12.6719C15.181 12.6719 15.793 12.9323 16.3008 13.4531C16.8216 13.9609 17.082 14.5794 17.082 15.3086C17.082 16.0247 16.8216 16.6432 16.3008 17.1641C15.793 17.6719 15.181 17.9258 14.4648 17.9258C13.7357 17.9258 13.1107 17.6719 12.5898 17.1641C12.082 16.6432 11.8281 16.0247 11.8281 15.3086ZM14.4648 3.58984C14.0091 3.58984 13.6185 3.74609 13.293 4.05859C12.9805 4.37109 12.8242 4.75521 12.8242 5.21094C12.8242 5.65365 12.9805 6.03776 13.293 6.36328C13.6185 6.67578 14.0091 6.83203 14.4648 6.83203C14.9076 6.83203 15.2852 6.67578 15.5977 6.36328C15.9232 6.03776 16.0859 5.65365 16.0859 5.21094C16.0859 4.75521 15.9232 4.37109 15.5977 4.05859C15.2852 3.74609 14.9076 3.58984 14.4648 3.58984ZM11.8281 5.21094C11.8281 4.48177 12.082 3.86328 12.5898 3.35547C13.1107 2.83464 13.7357 2.57422 14.4648 2.57422C15.181 2.57422 15.793 2.83464 16.3008 3.35547C16.8216 3.86328 17.082 4.48177 17.082 5.21094C17.082 5.9401 16.8216 6.55859 16.3008 7.06641C15.793 7.57422 15.181 7.82812 14.4648 7.82812C13.7357 7.82812 13.1107 7.57422 12.5898 7.06641C12.082 6.55859 11.8281 5.9401 11.8281 5.21094ZM7.51172 8.70703L12.6094 5.62109L13.1172 6.48047L8.01953 9.56641L7.51172 8.70703ZM12.668 14.8008L7.53125 11.7734L8.03906 10.9141L13.1758 13.9414L12.668 14.8008Z",
      fill: "currentColor"
    }
  )
);
const SvgShare = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Share_default = SvgShare;
